export interface AvatarProps {
  name: string | null | undefined;
  size?: 'sm' | 'md';
  className?: string;
  'aria-hidden'?: boolean;
}

const SIZE_CLASS: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'pn-avatar-sm',
  md: 'pn-avatar-md'
};

function initialsOf(name: string | null | undefined): string {
  if (!name) return '·';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '·';
  if (parts.length === 1) return parts[0]!.slice(0, 1).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

/**
 * Circular monogram avatar. Used in the signed-in shell's identity chip and
 * flyout. Initials derive from the first + last whitespace-separated token of
 * `name`. Empty name renders the middle-dot fallback.
 */
export function Avatar({ name, size = 'sm', className, ...rest }: AvatarProps) {
  const cls = ['pn-avatar', SIZE_CLASS[size], className].filter(Boolean).join(' ');
  return (
    <span className={cls} aria-hidden={rest['aria-hidden'] ?? true}>
      {initialsOf(name)}
    </span>
  );
}
